// extracted by mini-css-extract-plugin
export default {"eq":"Checkbox_eq__5vA9N","pl":"Checkbox_pl__ajlWT","shuffle":"Checkbox_shuffle__mA6Wt","repeat":"Checkbox_repeat__W6wNF"};